import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';

const Skills = ({className, items}) => {
  let skills;
  try {
    skills = JSON.parse(items);
  } catch (e) {
    console.error('could not parse skillz field', e);
  }
  if (!skills || !Array.isArray(skills) || !skills.length) {
    return null;
  }
  return (
    <div className={className}>
      <h6 className="f6 fw6">
        <FormattedMessage id="what_will_learn" />
      </h6>
      <ul className="mv3 pr4 f6 lh-solid ma0 pa0">
        {skills.map((item) => {
          return (
            <li className="pv2 green mr0" key={`course-skill-${item}`}>
              <span className="black">{item}</span>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

Skills.propTypes = {
  className: PropTypes.string,
  items: PropTypes.string,
};

export default Skills;
